import React from 'react';

const Earth = () => {
  const internships = [
    {
      company: 'Win Research Centre',
      role: 'Front-End Developer Intern',
      description:
        'Interned for project Coursify, a student guidance platform. Integrated a chatbot, built a sleek UI using SvelteKit, and helped users explore scholarships & universities with ease.',
      img: require('../images/wrc.jpg'),
      stack: 'SvelteKit, JS, UX',
    },
    {
      company: 'Tech Mahindra',
      role: 'Technology Intern',
      description:
        'Currently interning at Tech Mahindra, contributing to enterprise-grade projects, gaining real-world exposure to full-stack development, agile workflows, and cloud-based solutions.',
      img: require('../images/techm.png'),
      stack: 'Full Stack, Agile, Cloud',
    },
    {
      company: 'IG Group',
      role: 'Incoming Graduate Engineer Trainee (Sep 2025)',
      description:
        'Will be joining IG Group’s graduate engineering program to work on high-performance trading systems, learning from industry experts, and growing as a full-stack developer and cloud enthusiast.',
      img: require('../images/IG.png'),
      stack: 'FinTech, Full Stack, Trading Systems',
    },
  ];

  return (
    <section style={styles.section}>
      <h1 style={styles.header}>🛰️ Internships & Experience</h1>
      <div style={styles.timelineContainer}>
        <div style={styles.verticalLine} />
        {internships.map((item, index) => {
          const isLeft = index % 2 === 0;
          return (
            <div key={index} style={styles.timelineItem}>
              {isLeft ? (
                <>
                  <div style={{ ...styles.cardWrapper, justifyContent: 'flex-end' }}>
                    <div style={{ ...styles.content, marginRight: '30px' }}>
                      <img src={item.img} alt={item.company} style={styles.image} />
                      <h3 style={styles.company}>{item.company}</h3>
                      <p style={styles.role}>{item.role}</p>
                      <p style={styles.description}>{item.description}</p>
                      <div style={styles.techBadge}>{item.stack}</div>
                    </div>
                  </div>
                  <div style={styles.circle} />
                  <div style={styles.spacer} />
                </>
              ) : (
                <>
                  <div style={styles.spacer} />
                  <div style={styles.circle} />
                  <div style={{ ...styles.cardWrapper, justifyContent: 'flex-start' }}>
                    <div style={{ ...styles.content, marginLeft: '30px', textAlign: 'right' }}>
                      <img src={item.img} alt={item.company} style={styles.image} />
                      <h3 style={styles.company}>{item.company}</h3>
                      <p style={styles.role}>{item.role}</p>
                      <p style={styles.description}>{item.description}</p>
                      <div style={styles.techBadge}>{item.stack}</div>
                    </div>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '30px 20px',
    backgroundColor: 'transparent',
    color: 'white',
    marginTop:'-60px'
  },
  header: {
    fontSize: '2.5rem',
    color: '#00ffcc',
    textAlign: 'center',
    marginBottom: '40px',
  },
  timelineContainer: {
    position: 'relative',
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '20px 0',
  },
  verticalLine: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '4px',
    height: '100%',
    backgroundColor: '#00ffcc88',
    borderRadius: '2px',
    zIndex: 0,
  },
  timelineItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '50px 0',
    width: '100%',
    position: 'relative',
    zIndex: 1,
  },
  cardWrapper: {
    display: 'flex',
    width: '45%',
  },
  spacer: {
    width: '45%',
  },
  content: {
    backgroundColor: '#0a0a0a',
    borderRadius: '15px',
    padding: '25px',
    boxShadow: 'inset 0 0 30px rgba(0, 255, 204, 0.1), 0 0 18px rgba(0, 255, 204, 0.3)',
    color: 'white',
    maxWidth: '100%',
  },
  circle: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#00ffcc',
    border: '3px solid #000',
    zIndex: 2,
  },
  image: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginBottom: '15px',
    border: '2px solid #00ffcc',
  },
  company: {
    fontSize: '1.6rem',
    color: '#FFB400',
    margin: '10px 0',
  },
  role: {
    fontSize: '1.2rem',
    color: '#00ccff',
    marginBottom: '15px',
  },
  description: {
    fontSize: '1rem',
    lineHeight: '1.6',
  },
  techBadge: {
    backgroundColor: '#00ffcc',
    color: '#000',
    padding: '8px 14px',
    borderRadius: '30px',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    marginTop: '10px',
    display: 'inline-block',
  },
};

export default Earth;
